<template>
  <el-table
    :data="$props.users"
    stripe
    class="w-100"
  >
    <el-table-column
      label="Name"
    >
      <template v-slot="{ row }">
        {{ $_.get(row, 'name_full', '-') || '-' }}
        <el-tag
          v-if="row.deleted"
          size="mini"
          type="danger"
          class="ml-1"
        >
          Deleted
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      label="Postion"
      :formatter="row => $_.get(row, 'position', '-') || '-'"
    />
    <el-table-column
      label="Primary Phone"
    >
      <template v-slot="{ row }">
        <a
          v-if="$_.get(row, 'phone_primary')"
          :href="`tel:${$_.get(row, 'phone_primary', '-')}`"
        >
          {{ $_.get(row, 'phone_primary', '-') }}
        </a>
        <span v-else><i>None</i></span>
      </template>
    </el-table-column>
    <el-table-column
      label="Secondary Phone"
    >
      <template v-slot="{ row }">
        <a
          v-if="$_.get(row, 'phone_secondary')"
          :href="`tel:${$_.get(row, 'phone_secondary', '-')}`"
        >
          {{ $_.get(row, 'phone_secondary', '-') }}
        </a>
        <span v-else><i>None</i></span>
      </template>
    </el-table-column>
    <el-table-column
      label="Email"
    >
      <template v-slot="{ row }">
        <a
          v-if="$_.get(row, 'email')"
          :href="`mailto:${$_.get(row, 'email', '-')}`"
        >
          {{ $_.get(row, 'email', '-') }}
        </a>
        <span v-else><i>None</i></span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="right"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :user="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    users: {
      type: Array,
      required: true
    }
  }
}
</script>
